<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="dialog"
      :show-close="false"
      :before-close="handleBeforeClose"
      @close="closeDialog"
      width="800px"
    >
      <div class="header" slot="title">
        <div>
          <el-select
            v-model="year"
            placeholder="请选择学年"
            class="select"
            @change="changeYear"
          >
            <el-option
              v-for="item in yearList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-cascader
            v-model="cascaderSubject"
            :options="subjectList"
            @change="changeSubject"
            class="select"
          ></el-cascader>
        </div>

        <el-tabs v-model="classId" class="tabs">
          <el-tab-pane
            v-for="tab in classList"
            :key="tab.classId"
            :label="tab.className"
            :name="tab.classId"
          >
          </el-tab-pane>
        </el-tabs>

        <el-link
          type="primary"
          @click="closeDialog"
          :disabled="!selectedHomeworkId"
          class="link"
          >关闭</el-link
        >
      </div>
      <div
        class="list"
        v-infinite-scroll="getMore"
        :infinite-scroll-immediate="false"
        :infinite-scroll-distance="10"
      >
        <template v-if="homeworkList.length > 0">
          <div
            v-for="(item, index) in homeworkList"
            :key="index"
            class="homework-item"
            @click="handleHomeworkClick(item)"
          >
            <div class="title" :title="item.homeworkName">
              {{ item.homeworkName }}
            </div>
            <div class="svg-item">
              <img src="../../assets/image/number.png" class="svg" />上交人数:
              {{ item.submitCount }}/{{ item.studentCount }}人
            </div>
            <div class="svg-item">
              <img src="../../assets/image/time.png" class="svg" />更新时间:
              {{ formatDate(item.creationTime) }}
            </div>
            <div class="tag">
              <span v-if="isSelectedHomework(item)">当前</span>
            </div>
          </div>
        </template>

        <el-empty description="暂无数据" v-else style="height: 100%"></el-empty>
      </div>
    </el-dialog>

    <el-input
      v-model="homeworkName"
      placeholder="请输入内容"
      class="select-homework"
      @focus="dialogVisible = true"
    ></el-input>
  </div>
</template>
  
  <script>
import {
  getGradeAndSubjects,
  getTeachClassCourse,
  getUserInfo,
} from "../../apis/zhxApi";
import {
  getHomeworkList,
  getHomeworkApi,
  getAllSubjectsApi,
} from "../../apis/explainApi";
import { convertGrades, filterSubject } from "../../utils/baseInfo";

export default {
  props: {
    homeworkDialogVisible: {
      type: Boolean,
      required: true,
    },
    homeworkId: {
      type: [String, Number],
    },
    defaultClassId: {
      type: String,
    },
  },
  data() {
    return {
      yearList: undefined,
      subjectList: undefined,
      classList: undefined,
      allClassList: undefined,
      classId: undefined,
      year: undefined,
      pageNum: 1,
      pageSize: 8,
      pageCount: 0,
      homeworkList: [],
      dialogVisible: false,
      loading: false,
      selectedHomeworkId: undefined,
      selectedClassId: undefined,
      selectedHomeworkName: undefined,
      homeworkName: undefined,
      cascaderSubject: undefined,
    };
  },
  mounted() {
    this.getAllSubjects();
    this.dialogVisible = this.homeworkDialogVisible;
    if (this.homeworkId && this.defaultClassId) {
      getHomeworkApi(this.homeworkId).then((res) => {
        this.cascaderSubject = [
          res.data.homework.grade,
          res.data.homework.subject,
        ];
        this.classId = this.defaultClassId;
        this.fetchUserInfo();
        this.handleHomeworkClick({
          homeworkId: this.homeworkId,
          homeworkName: res.data.homework.name,
        });
        this.homeworkName = this.selectedHomeworkName;
      });
    } else {
      this.fetchUserInfo();
    }
  },
  computed: {
    subject() {
      return this.cascaderSubject && this.cascaderSubject.length == 2
        ? this.cascaderSubject[1]
        : this.cascaderSubject;
    },
    grade() {
      return this.cascaderSubject && this.cascaderSubject.length == 2
        ? this.cascaderSubject[0]
        : this.cascaderSubject;
    },
  },
  methods: {
    handleHomeworkClick(item) {
      if (this.selectedHomeworkId == item.homeworkId && this.selectedClassId == this.classId) {
        return;
      }
      this.selectedHomeworkId = item.homeworkId;
      this.selectedClassId = this.classId;
      this.selectedHomeworkName = item.homeworkName;

      this.$emit("changeHomeworkId", {
        homeworkId: this.selectedHomeworkId,
        classId: this.classId,
        homeworkName: this.selectedHomeworkName,
      });
      this.homeworkName = this.selectedHomeworkName;
    },

    closeDialog() {
      this.dialogVisible = false;
    },
    handleBeforeClose(done) {
      if (this.selectedHomeworkId === undefined) {
        this.$message.error("请先选择作业");
        return;
      }

      done();
    },

    fetchUserInfo() {
      getUserInfo().then((res) => {
        this.year = res.data.schoolYear;
        this.computedYearList(this.year);
        this.getSubjectAndGrade();
      });
    },
    computedYearList(currentYear) {
      const defaultYearList = [
        { value: 2020, label: "2020-2021学年" },
        { value: 2021, label: "2021-2022学年" },
        { value: 2022, label: "2022-2023学年" },
        { value: 2023, label: "2023-2024学年" },
      ];
      let defaultYear = 2023;
      while (defaultYear < currentYear) {
        defaultYear += 1; // 增加年份
        defaultYearList.push({
          value: defaultYear,
          label: `${defaultYear}-${defaultYear + 1}学年`,
        });
      }
      this.yearList = defaultYearList.reverse();
    },
    getAllSubjects() {
      getAllSubjectsApi().then((response) => {
        if (response.data.subjects && response.data.subjects.length > 0) {
          this.constant.subjectMap = {};
          response.data.subjects.forEach((subject) => {
            this.constant.subjectMap[subject.type] = {
              k: subject.value,
              v: subject.text,
            };
          });
        }
      });
    },
    getSubjectAndGrade() {
      this.subjectList = [];
      this.classList = [];
      this.allClassList = [];
      getGradeAndSubjects().then((response) => {
        let subjectList = [];
        if (response.data.grades && response.data.grades.length > 0) {
          const grades = convertGrades(response.data.grades);
          grades.forEach((grade) => {
            const item = {
              value: grade.value,
              label: grade.label,
              children: [],
            };
            if (response.data.subjects && response.data.subjects.length > 0) {
              const subjects = response.data.subjects.map((subject) => ({
                value: this.constant.subjectMap[subject].k,
                label: this.constant.subjectMap[subject].v,
              }));
              item.children = filterSubject(grade.value, subjects);
            }
            subjectList.push(item);
          });
        }

        this.subjectList = subjectList;
        if (
          this.cascaderSubject === undefined &&
          this.subjectList &&
          this.subjectList.length > 0
        ) {
          this.cascaderSubject = [];
          this.subjectList.forEach((grade) => {
            if (grade && this.cascaderSubject.length < 2) {
              this.cascaderSubject.push(grade.value);
              grade.children.forEach((subject) => {
                if (subject && this.cascaderSubject.length < 2) {
                  this.cascaderSubject.push(subject.value);
                }
              });
            }
          });
        }
        this.classId = undefined;
        this.getCLassCourse();
      });
    },
    getCLassCourse() {
      getTeachClassCourse(this.year).then((response) => {
        this.allClassList = response.data.classCourseList;
        this.classList = response.data.classCourseList.filter(
          (classItem) =>
            classItem.subject == this.subject && this.grade == classItem.grade
        );
        if (
          this.classId === undefined &&
          this.classList &&
          this.classList.length > 0
        ) {
          this.classId = this.classList[0].classId;
        }
      });
    },
    getPaperList() {
      getHomeworkList(
        this.subject,
        this.pageNum,
        this.pageSize,
        this.classId
      ).then((response) => {
        this.pageCount = response.data.pagination.pageCount;
        response.data.homeworkList.forEach((homework) => {
          if (
            this.homeworkList.find(
              (item) => item.homeworkId === homework.homeworkId
            )
          )
            return;
          this.homeworkList.push(homework);
        });
        this.loading = false;
      });
    },
    changeSubject() {
      this.classId = undefined;
      this.classList = JSON.parse(JSON.stringify(this.allClassList)).filter(
        (classItem) =>
          classItem.subject == this.subject && this.grade == classItem.grade
      );
      if (
        this.classId === undefined &&
        this.classList &&
        this.classList.length > 0
      ) {
        this.classId = this.classList[0].classId;
      }
      this.homeworkList = [];
      this.pageNum = 1;
      // this.getPaperList();
    },
    getMore() {
      if (this.loading || this.pageNum >= this.pageCount) return;
      this.loading = true;
      this.pageNum++;
      this.getPaperList();
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString(); // 根据需要格式化日期
    },
    changeClass() {
      this.pageNum = 1;
      this.homeworkList = [];
      this.getPaperList();
    },
    changeYear() {
      this.classId = undefined;
      this.getCLassCourse();
    },
    isSelectedHomework(item) {
      return (
        this.selectedClassId == this.classId &&
        item.homeworkId == this.selectedHomeworkId
      );
    },
  },
  watch: {
    classId(newValue, oldValue) {
      if (newValue != oldValue && newValue != 0 && newValue && oldValue != 0)
        this.changeClass();
    },
    homeworkDialogVisible(newValue) {
      this.dialogVisible = newValue;
    },
  },
};
</script>
  
  <style scoped>
.select-homework {
  width: 20%;
  position: absolute;
  right: 240px;
  bottom: 0;
}
.select {
  width: 150px;
}
.tabs {
  max-width: calc(100% - 360px);
}
.header {
  width: calc(100% - 24px);
  height: 50px;
  border-radius: 12px;
  background: #fff;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list {
  background: #f8fafc;
  padding: 0 16px;
  padding-bottom: 12px;
  height: calc(72vh - 92px);
  overflow: auto;
  border-radius: 0 0 12px 12px;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
.homework-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #6b7280;
  margin-top: 12px;
  height: 70px;
  padding: 0 16px;
  border-radius: 12px;
  opacity: 1;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)),
    #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}
.title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0px;
  color: #111827;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tag {
  width: 32px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0px;
  color: #2563eb;
}
.link {
  color: #2563eb;
}
.svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.svg-item {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/explain/SelectHomework.vue